var _defs, _metadata;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLystedOrig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87.514755mm",
    height: "33.297813mm",
    viewBox: "0 0 87.514755 33.297813",
    id: "svg60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs54"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-62.075954,-132.18443)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.26458333,0,0,0.26458333,38.858767,61.728532)",
    id: "bYtSuF_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    id: "path7",
    d: "m 137.72,392.14 c 0,-5.56 0,-11.12 0,-16.57 8.03,-2.05 13.54,-8.07 14.49,-15.75 0.15,-1.25 -0.44,-2.66 -0.91,-3.92 -7.07,-18.77 -14.18,-37.53 -21.26,-56.3 -0.55,-1.46 -1,-2.96 -1.63,-4.84 5.83,0 11.38,-0.27 16.86,0.19 1.35,0.11 3,2.44 3.64,4.09 4.18,10.66 8.12,21.41 12.14,32.12 0.22,0.58 0.49,1.14 1,2.31 0.67,-1.62 1.19,-2.77 1.63,-3.94 3.82,-10.23 7.7,-20.44 11.37,-30.73 1.07,-3.01 2.58,-4.41 5.95,-4.2 4.71,0.29 9.45,0.07 14.61,0.07 -1.29,3.58 -2.4,6.83 -3.61,10.03 -8.27,21.91 -16.69,43.77 -24.8,65.74 -3.97,10.76 -9.84,19.25 -21.89,21.67 -2.53,0.03 -5.06,0.03 -7.59,0.03 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    id: "path9",
    d: "m 87.75,266.29 c 6.09,0 12.19,0 18.82,0 0,1.52 0,2.73 0,3.94 0,19.79 -0.01,39.58 0.01,59.37 0.01,8.18 3.75,11.88 12.02,11.9 6.63,0.02 13.27,0.07 19.9,-0.04 1.86,-0.03 2.81,0.51 3.45,2.33 1.94,5.53 4.07,10.99 6.14,16.5 -0.43,0.28 -0.68,0.59 -0.93,0.59 -11.47,-0.06 -22.97,0.39 -34.39,-0.35 -13.88,-0.91 -22.73,-10.22 -24.33,-24.16 -0.12,-1.02 -0.44,-2.01 -0.67,-3.02 -0.02,-22.37 -0.02,-44.71 -0.02,-67.06 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    id: "path13",
    d: "m 176.06,360.43 c 2.31,-6.18 4.46,-12.07 6.79,-17.89 0.23,-0.57 1.52,-0.98 2.34,-1.01 2.84,-0.12 5.69,-0.01 8.53,-0.04 5.36,-0.07 7.79,-1.99 8.47,-7.35 0.66,-5.21 0.91,-10.48 1.23,-15.73 1.02,-16.38 14.13,-25.98 25.74,-25.68 5.14,0.13 10.28,0.02 15.74,0.02 0,-9.1 0,-17.49 0,-26.09 6.26,0 12.2,0 18.5,0 0,8.48 0,16.96 0,25.88 11.93,0 23.53,0 35.13,0 -6.54,5.1 -11.97,10.82 -16.67,17.32 -0.67,0.93 -2.56,1.3 -3.91,1.35 -4.62,0.16 -9.24,0.06 -14.36,0.06 0,2.03 0.01,3.87 0,5.72 -0.02,4.21 -0.08,8.43 -0.09,12.64 -0.01,7.74 4.21,11.96 11.9,11.91 1.58,-0.01 3.15,0 4.97,0 0,6.25 0,12.41 0,18.58 -16.03,3.63 -32.03,-4.53 -34.38,-21.5 -0.91,-6.54 -0.69,-13.23 -0.93,-19.85 -0.08,-2.19 -0.01,-4.39 -0.01,-6.87 -5.51,0 -10.64,-0.22 -15.74,0.08 -3.22,0.19 -5.23,2.7 -5.62,6.27 -0.69,6.38 -0.97,12.81 -1.89,19.15 -2.06,14.17 -11.79,22.69 -26.02,23 -6.42,0.15 -12.84,0.03 -19.72,0.03 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    id: "path15",
    d: "m 400.23,298.48 c 0,-10.82 0,-21.01 0,-31.38 6.08,0 11.94,0 18.28,0 0,1.08 0,2.19 0,3.3 0,19.08 0.01,38.15 0,57.23 -0.01,17.21 -12.67,31.4 -29.29,32.84 -18.64,1.62 -33.58,-9.55 -36.54,-27.32 -2.71,-16.29 5.57,-32.46 19.6,-37.9 8.74,-3.39 17.31,-2.83 25.5,1.92 0.61,0.37 1.25,0.68 2.45,1.31 z m -14.85,12 c -3.94,-0.16 -7.17,1.35 -9.86,4.14 -6.15,6.37 -6.59,16.49 -1.03,23.37 5.17,6.4 13.99,7.13 20.12,1.64 3.2,-2.87 4.89,-6.53 5.45,-10.74 1.27,-9.45 -5.82,-18.34 -14.68,-18.41 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    id: "path17",
    d: "m 306.46,339.5 c 4.47,6.33 15.61,6.8 20.93,0.71 2.16,-2.47 4.37,-3.17 7.39,-3.06 4.62,0.16 9.24,0.04 13.89,0.04 -1.46,10.91 -11.26,20.6 -23.22,23.15 -19.12,4.07 -36.48,-7.11 -40.67,-26.18 -3.13,-14.27 3.31,-29.1 15.77,-36.31 12.58,-7.27 28.22,-5.84 38.49,3.53 5.16,4.7 8.12,10.63 9.76,17.33 0.48,1.96 -0.05,3 -2.02,3.81 -12.53,5.16 -25.01,10.46 -37.51,15.72 -0.93,0.38 -1.85,0.82 -2.81,1.26 z m -4.78,-15.1 c 8.85,-3.73 17.02,-7.17 25.58,-10.78 -4.87,-4.03 -9.93,-4.77 -15.18,-2.91 -5.95,2.1 -9.06,6.76 -10.4,13.69 z",
    className: "st0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLystedOrig);
export default __webpack_public_path__ + "static/media/lysted-orig.69a89e22a76972ddc30c723b79190023.svg";
export { ForwardRef as ReactComponent };